import React from "react";
import Modal from "react-bootstrap/Modal";
import DISTRIBUTION_PATTERNS from "../../json/DistributionPattern.json";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux/es/exports";

const ModalGenerateDistribution = (props) => {
  const dispatch = useDispatch();
  const [selectedDistribution, setSelectedDistribution] = useState(
    props?.distribution?.type
  );
  const isUpdatedDistribution = useSelector(
    (state) => state?.isUpdatedDistribution
  );

  const currentDistribution = useSelector(
    (state) => state?.currentDistribution
  );
  const [isLoading, setIsLoading] = useState(true);
  const saveMode = useSelector(
    (state) => state?.isInActiveSaveDistributionMode
  );

  const [isInActiveSaveDistributionMode, setIsInActiveSaveDistributionMode] =
    useState(true);

  let minimum = props?.distribution?.min;
  let maximum = props?.distribution?.max;
  let likely = props?.distribution?.likely;

  const [errorMessage, setErrorMessage] = useState();

  useEffect(() => {
    props?.setDistribution({
      ...props?.distribution,
      type: currentDistribution.type,
      value: currentDistribution.value,
      mean: currentDistribution.mean,
      sigma: currentDistribution.sigma,
      min: currentDistribution.min,
      max: currentDistribution.max,
      likely: currentDistribution.likely,
    });
    setSelectedDistribution(currentDistribution.type);
  }, [isUpdatedDistribution]);

  useEffect(() => {
    setIsInActiveSaveDistributionMode(saveMode);
  }, [saveMode]);

  useEffect(() => {
    if (currentDistribution.type === undefined) {
      return;
    }
    let tempValue = undefined;
    let tempMean = undefined;
    let tempSigma = undefined;
    let tempMin = undefined;
    let tempMax = undefined;
    let tempLikely = undefined;

    if (currentDistribution.type === selectedDistribution) {
      tempValue = currentDistribution.value;
      tempMean = currentDistribution.mean;
      tempSigma = currentDistribution.sigma;
      tempMin = currentDistribution.min;
      tempMax = currentDistribution.max;
      tempLikely = currentDistribution.likely;
    } else {
      for (const pattern of DISTRIBUTION_PATTERNS) {
        if (pattern.type === selectedDistribution) {
          for (const parameter of pattern.params) {
            if (parameter.id === "value") {
              tempValue = parameter.defaultValue.toFixed(
                parameter.numberOfDecimals
              );
            }
            if (parameter.id === "mean") {
              tempMean = parameter.defaultValue.toFixed(
                parameter.numberOfDecimals
              );
            }
            if (parameter.id === "sigma") {
              tempSigma = parameter.defaultValue.toFixed(
                parameter.numberOfDecimals
              );
            }
            if (parameter.id === "min") {
              tempMin = parameter.defaultValue.toFixed(
                parameter.numberOfDecimals
              );
            }
            if (parameter.id === "max") {
              tempMax = parameter.defaultValue.toFixed(
                parameter.numberOfDecimals
              );
            }
            if (parameter.id === "likely") {
              tempLikely = parameter.defaultValue.toFixed(
                parameter.numberOfDecimals
              );
            }
          }
        }
      }
    }
    props?.setDistribution({
      ...props?.distribution,
      type: selectedDistribution,
      value: tempValue,
      mean: tempMean,
      sigma: tempSigma,
      min: tempMin,
      max: tempMax,
      likely: tempLikely,
    });

    minimum = tempMin;
    maximum = tempMax;
    likely = tempLikely;

    setErrorMessage();
    if (isLoading) {
      setIsLoading(false);
      return;
    } else {
      setIsInactiveDistributionMode(false);
    }
  }, [selectedDistribution]);

  const changeValue = (event) => {
    event.preventDefault();
    const id = event.target.id;
    const value = event.target.value === "" ? "0.00" : event.target.value;
    if (isNaN(value)) {
      return;
    }
    if (id === "value") {
      props?.setDistribution({
        ...props?.distribution,
        value: value,
      });
      checkForErrors(id, value);
    }
    if (id === "mean") {
      props?.setDistribution({
        ...props?.distribution,
        mean: value,
      });
      checkForErrors(id, value);
    }
    if (id === "sigma") {
      props?.setDistribution({
        ...props?.distribution,
        sigma: value,
      });
      checkForErrors(id, value);
    }
    if (id === "min") {
      props?.setDistribution({
        ...props?.distribution,
        min: value,
      });
      minimum = value;
      checkForErrors(id, value);
    }
    if (id === "max") {
      props?.setDistribution({
        ...props?.distribution,
        max: value,
      });
      maximum = value;
      checkForErrors(id, value);
    }
    if (id === "likely") {
      props?.setDistribution({
        ...props?.distribution,
        likely: value,
      });
      likely = value;
      checkForErrors(id, value);
    }
  };

  const checkForErrors = (paramId, value) => {

    // TRIANGULAR CASE
    if (paramId === "likely" || paramId === "min" || paramId === "max") {
      if (parseFloat(likely) < minimum || parseFloat(likely) > maximum) {
        setErrorMessage(
          "Likely must be greater than 'min' and less than 'max'"
        );
        setIsInactiveDistributionMode(true);
        return;
      } else {
        setErrorMessage();
        setIsInactiveDistributionMode(false);
      }
    }

    // MINIMUM MAXIMUM CASE
    if (paramId === "min" || paramId === "max") {
      if (parseFloat(maximum) <= parseFloat(minimum)) {
        setErrorMessage("Maximum value must be greater than the minimum value");
        setIsInactiveDistributionMode(true);
        return;
      } else {
        setErrorMessage();
        setIsInactiveDistributionMode(false);
      }
    }
    let defaultMinValue = 0;
      let defaultMaxValue = 0;
      for (const pattern of DISTRIBUTION_PATTERNS) {
        if (pattern.type === props?.distribution?.type) {
          for (const parameter of pattern.params) {
            if (parameter.id === paramId) {
              defaultMinValue = parameter.minValue;
              defaultMaxValue = parameter.maxValue;
              break;
            }
          }
        }
      }

      if (
        defaultMaxValue <= parseFloat(value) ||
        defaultMinValue >= parseFloat(value)
      ) {
        setErrorMessage(
          `'${paramId}' must be in interval from ${defaultMinValue} to ${defaultMaxValue}`
        );
        setIsInactiveDistributionMode(true);
        return;
      } else {
        setErrorMessage();
        setIsInactiveDistributionMode(false);
      }
  };

  const setIsInactiveDistributionMode = (flag) => {
    dispatch({
      type: "SET IS INACTIVE DISTRIBUTION MODE",
      payload: flag,
    });
  };

  return (
    <div>
      <Modal
        show={props.isShowWindow}
        onHide={props.onHide}
        size="lg"
        centered={true}
        backdrop={true}
      >
        <Modal.Body>
          <h4 className="mt-2 mb-4">{props.title}</h4>
          {props?.distribution?.type && (
            <div className="flex">
              <div className="distribution-block">
                <div className="distribution-type-item">
                  <input
                    type="radio"
                    name="distribution"
                    id="CONSTANT"
                    defaultChecked={props?.distribution?.type === "CONSTANT"}
                    onClick={(e) => setSelectedDistribution(e.target.id)}
                  />
                  <label
                    className="distribution-type-item-input"
                    htmlFor="CONSTANT"
                  >
                    CONSTANT
                  </label>
                </div>
                <div className="distribution-type-item">
                  <input
                    type="radio"
                    name="distribution"
                    id="UNIFORM"
                    defaultChecked={props?.distribution?.type === "UNIFORM"}
                    onClick={(e) => setSelectedDistribution(e.target.id)}
                  />
                  <label
                    className="distribution-type-item-input"
                    htmlFor="UNIFORM"
                  >
                    UNIFORM
                  </label>
                </div>
                <div className="distribution-type-item">
                  <input
                    type="radio"
                    name="distribution"
                    id="TRIANGULAR"
                    defaultChecked={props?.distribution?.type === "TRIANGULAR"}
                    onClick={(e) => setSelectedDistribution(e.target.id)}
                  />
                  <label
                    className="distribution-type-item-input"
                    htmlFor="TRIANGULAR"
                  >
                    TRIANGULAR
                  </label>
                </div>
              </div>
              <div className="vl"></div>
              <div className="distribution-block">
                {parseFloat(props?.distribution?.value) >= 0 &&
                  props?.distribution?.value !== undefined && (
                    <div>
                      <label htmlFor="value"> value (days)</label>
                      <input
                        className="form-control form-control-sm"
                        type="text"
                        name="value"
                        id="value"
                        value={props?.distribution?.value}
                        onChange={(e) => changeValue(e)}
                      />
                    </div>
                  )}
                {parseFloat(props?.distribution?.mean) >= 0 &&
                  props?.distribution?.mean !== undefined && (
                    <div>
                      <label htmlFor="mean"> mean (days)</label>
                      <input
                        className="form-control form-control-sm"
                        type="text"
                        name="mean"
                        id="mean"
                        value={props?.distribution?.mean}
                        onChange={(e) => changeValue(e)}
                      />
                    </div>
                  )}
                {parseFloat(props?.distribution?.sigma) >= 0 &&
                  props?.distribution?.sigma !== undefined && (
                    <div>
                      <label htmlFor="sigma"> sigma (days)</label>
                      <input
                        className="form-control form-control-sm"
                        type="text"
                        name="sigma"
                        id="sigma"
                        value={props?.distribution?.sigma}
                        onChange={(e) => changeValue(e)}
                      />
                    </div>
                  )}
                {parseFloat(props?.distribution?.min) >= 0 &&
                  props?.distribution?.min !== undefined && (
                    <div>
                      <label htmlFor="min"> min (days)</label>
                      <input
                        className="form-control form-control-sm"
                        type="text"
                        name="min"
                        id="min"
                        value={props?.distribution?.min}
                        onChange={(e) => changeValue(e)}
                      />
                    </div>
                  )}
                {parseFloat(props?.distribution?.likely) >= 0 &&
                  props?.distribution?.likely !== undefined && (
                    <div>
                      <label htmlFor="likely"> likely (days)</label>
                      <input
                        className="form-control form-control-sm"
                        type="text"
                        name="likely"
                        id="likely"
                        value={props?.distribution?.likely}
                        onChange={(e) => changeValue(e)}
                      />
                    </div>
                  )}
                {parseFloat(props?.distribution?.max) >= 0 &&
                  props?.distribution?.max !== undefined && (
                    <div>
                      <label htmlFor="max"> max (days)</label>
                      <input
                        className="form-control form-control-sm"
                        type="text"
                        name="max"
                        id="max"
                        value={props?.distribution?.max}
                        onChange={(e) => changeValue(e)}
                      />
                    </div>
                  )}
                {errorMessage && (
                  <div className="input-error-tooltip padding-top-5">
                    <span>{errorMessage}</span>
                  </div>
                )}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className="large-button grey" onClick={props.onHide}>
            CLOSE
          </button>
          <button
            className="large-button green"
            onClick={props.postDistribution}
            disabled={isInActiveSaveDistributionMode}
          >
            SET DISTRIBUTION, SAVE &amp; SIMULATE
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModalGenerateDistribution;
